import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RdsProgressSpinnerComponent } from '@rds/angular-components';

@Component({
  selector: 'inexp-work-in-progress',
  imports: [RdsProgressSpinnerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="wip-container" role="status" aria-live="polite">
      <rds-progress-spinner label="Loading..."></rds-progress-spinner>
      <h1 class="ui-heading-2">We're working on it</h1>
      <p class="ui-body-m">This page is currently under construction. Check back soon.</p>
    </div>
  `,
  styles: `
    .wip-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 16px;
      min-height: 60vh;
      text-align: center;
      padding: 40px 24px;
    }
  `,
})
export class WorkInProgressComponent {}
